import styled, { css } from "styled-components";
import { color, space, typography } from "styled-system";

export const Header = styled.div`
  font-family: "Chubs";
  font-size: 48px;
  @media ${"only screen and (min-width: 768px)"} {
    font-size: 64px;
  }
  @media ${"only screen and (min-width: 1024px)"} {
    font-size: 72px;
  }
  ${({ shadow }) =>
    shadow &&
    `text-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15), -5px -5px 15px rgba(255, 255, 255, 0.15);`}

  ${color};
  ${space};
  ${typography};
`;

export const Subheader = styled.div`
  font-family: "Chubs";
  font-size: 30px;
  letter-spacing: -1px;
  @media ${"only screen and (min-width: 768px)"} {
    font-size: 36px;
  }
  @media ${"only screen and (min-width: 1024px)"} {
    font-size: 36px;
  }
  ${({ shadow }) =>
    shadow &&
    `text-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15), -5px -5px 15px rgba(255, 255, 255, 0.15);`}

  ${color};
  ${space};
  ${typography}

  animation: ${({ animation, animationLength }) =>
    animation &&
    animationLength &&
    css`
      ${animation} ${animationLength} ${({ theme }) => theme.cubicBezier}
    `};
  animation-delay: ${({ animationDelay }) =>
    animationDelay &&
    css`
      ${animationDelay}
    `};
  animation-fill-mode: forwards;
`;

export const ButtonText = styled.div`
  font-family: "Chubs";
  font-size: 36px;
  @media ${"only screen and (min-width: 768px)"} {
    font-size: 48px;
  }
  @media ${"only screen and (min-width: 1024px)"} {
    font-size: 48px;
  }
  ${color};
  ${space};
  ${typography}
`;
